module.exports = (function remoteLoader(remoteName) {
    const REMOTE_PATHS = {
        informationArchitecture: 'information-architecture',
        dashboard: 'dashboard',
        inSeasonWeb: 'tcc-in-season-web',
        seasonReportsWeb: 'tcc-season-reports-web',
        programsPlugin: 'programs-plugin',
        dmbWeb: 'dmb-web',
        scriptCreator: 'script-creator',
        tccScriptCreatorPlugin: 'tcc-script-creator-plugin',
        settings: 'settings',
        tccReportsPlugin: 'tcc-reports-plugin',
        dataInboxWeb: 'data-inbox-web',
        fixitTool: 'fixit-tool',
        dataHub: 'data-hub',
        appsMarketplacePlugin: 'apps-marketplace-plugin',
        cropPlanning: 'crop-planning',
        operationHub: 'operation-hub',
        fieldSelectionWeb: 'field-selection-web',
        variableRate: 'variable-rate',
        ardExport: 'tcc-ard-export',
    };
    
    const getRemoteURL = () => {
        const nonProdBundle = sessionStorage.getItem(REMOTE_PATHS[remoteName]);
        if (nonProdBundle) {
            return nonProdBundle;
        }
        return `https://climate.com/static/global/${REMOTE_PATHS[remoteName]}/latest/bundle.js`;
    };
    // Stored init arguments (shared scope) from when webpack MF calls init() at startup.
    // The real container.init() is deferred until the bundle is actually loaded.
    let storedInitArgs = null;
    // Singleton promise for the real container — only created when get() is first called.
    let containerPromise = null;
    const loadContainer = () => {
        if (!containerPromise) {
            containerPromise = new Promise((resolve, reject) => {
                const remoteUrlWithVersion = getRemoteURL();
                const script = document.createElement('script');
                script.src = remoteUrlWithVersion;
                script.onload = () => {
                    const remoteModule = window[remoteName];
                    if (storedInitArgs) {
                        try {
                            remoteModule.init(...storedInitArgs);
                        }
                        catch (e) {
                            console.log(`remote ${remoteName} container already initialized`);
                        }
                    }
                    resolve(remoteModule);
                };
                script.onerror = () => {
                    const message = `Unable to load ${remoteName}. Make sure a valid pre-released commit hash is used as input.`;
                    console.error(message);
                    reject(message);
                };
                document.head.appendChild(script);
            });
        }
        return containerPromise;
    };
    // Resolve immediately with a lazy proxy — no script tag created yet.
    // webpack MF will call init() at startup (we store the args) and only
    // calls get() when an actual import('remote/Module') is executed.
    return Promise.resolve({
        init: (...args) => {
            storedInitArgs = args;
        },
        get: (request) => loadContainer().then((container) => container.get(request)),
    });
})('fieldSelectionWeb');